// extracted by mini-css-extract-plugin
export default {"create-account-page":"style_create-account-page__-rsYe","create-account-page-cta":"style_create-account-page-cta__yk7J4"};